import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "dayjs/locale/nl";
import dayjs from "dayjs";
import { resetData, resetSalesForValue, setRun } from "../../redux/actions";
import { resetScheme } from "../../redux/actions/index";
import { resetEd1 } from "../../redux/actions/ed1AndEd2";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { useRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import Fade from "@mui/material/Fade";
import Slide from "@mui/material/Slide";
import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { validatePartnerRoleType } from "../../utils/common";
import { Button } from "@material-ui/core";
import { setSelectedSite } from "../../redux/actions/homeAction";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export const CustomHeader = (props) => {
  const [showAdminOptions, setshowAdminOptions] = useState(false);
  const {
    partnerRoleType,
    filterValue: { sites, site },
  } = useSelector((state) => state.homeReducer);
  const [dateButton, setDateButton] = useState({
    open: false,
    Transition: Fade,
  });

  const handleClose = () => {
    setDateButton({
      ...dateButton,
      open: false,
    });
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleClick = (Transition) => {
    setDateButton({
      open: true,
      Transition,
    });
  };

  let history = useHistory();
  if (global.isSessionExpired === true) {
    // window.history.replaceState("", "", "/sessionExpired");
    history.push("/sessionExpired"); //<Redirect to="/sessionExpired" />;
    // return (
    //   <Route
    //     exact={true}
    //     key={index}
    //     path={el.path}
    //     render={() => this.onRouteChange(el.component, el)}
    //   />
    // );
  }
  const dispatch = useDispatch();

  const {
    filterValue: { partnerName, orgId, agentId, name },
    headerSelectedDateFrom,
    headerSelectedDateTo,
    dateModule,
    headerUnit,
    showHeader,
    tilesData,
    isPayoutDashboard,
  } = useSelector((state) => state.homeReducer);

  const [selectedDateFrom, setSelectedDateFrom] = React.useState(
    headerSelectedDateFrom.replace(/-/g, " "),
  );
  const [selectedDateTo, setSelectedDateTo] = React.useState(
    headerSelectedDateTo.replace(/-/g, " "),
  );
  const [values, setValues] = React.useState({
    unit: "1000",
    label: "(K)",
  });

  const [toggleCalendarFilter, setToggleCalendarFilter] = React.useState(true);

  const isAdjustingDates = useRef(false);
  const [toMax, setToMax] = useState(new Date());

  useEffect(() => {
    if (isAdjustingDates.current) return;
    setSelectedDateFrom(headerSelectedDateFrom.replace(/-/g, " "));
  }, [headerSelectedDateFrom]);

  useEffect(() => {
    if (isAdjustingDates.current) return;
    setSelectedDateTo(headerSelectedDateTo.replace(/-/g, " "));
  }, [headerSelectedDateTo]);

  let fromMin = new Date();
  let maxMessage = "Date should not be more than max date";
  fromMin.setMonth(fromMin.getMonth() - 3);
  maxMessage = "Date should not be more than 7 days";
  // fromMin=new Date(selectedDateTo);
  // fromMin.setDate(fromMin.getDate() - 6)
  if (dateModule !== "ESTEL") {
    fromMin = new Date();
    maxMessage = "Date should not be more than max date";
    fromMin.setMonth(fromMin.getMonth() - 6);
  }

  if (isPayoutDashboard?.payout) {
    fromMin = new Date();
    fromMin.setMonth(fromMin.getMonth() - 6);
  }

  if (isPayoutDashboard?.clawback) {
    fromMin = new Date();
    fromMin.setMonth(fromMin.getMonth() - 12);
    fromMin.setDate(1);
  }

  useEffect(() => {
    if (dateModule === "ESTEL") {
      setToMax(new Date(selectedDateFrom));
      setToMax(() => {
        let newDate;
        newDate.setDate(toMax.getDate() + 6);
        return newDate;
      });
    } else {
      setToMax(new Date());
    }
  }, []);

  useEffect(() => {
    if (dateModule === "ESTEL") {
      const sevenDays = new Date(selectedDateTo);
      sevenDays.setDate(sevenDays.getDate() - 6);
      setSelectedDateFrom(dayjs(sevenDays));
      props.selectedDateFromHandler(dayjs(sevenDays));
      resetApiData();
      //  props.selectedDateFromHandler(dayjs(sevenDays))
      //(()=>{props.selectedDateFromHandler(selectedDateFrom)})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateModule, selectedDateTo]);

  // Do not force "one month ago" into Redux on clawback entry — header dates are global; that
  // overwrote From while leaving To from the previous dashboard and broke cross-dashboard sync.

  // Intentionally no "force this week into Redux" on payout entry: that overwrote dates preserved
  // after Home/back and made filterSchemeType use 31-Mar / current while pickers still showed Dec.

  useEffect(() => {
    if (isAdjustingDates.current) return;
    if (!isPayoutDashboard?.payout || isPayoutDashboard?.clawback) {
      setToMax(new Date());
      return;
    }

    const currentDate = dayjs();
    const fromDateMonth = dayjs(selectedDateFrom).month();
    const toDateMonth = dayjs(selectedDateTo).month();
    const lastDayOfMonth = dayjs(selectedDateFrom).endOf("month");
    const fromDatePlus6 = dayjs(selectedDateFrom).add(6, "day");

    let maxAllowedToDate = fromDatePlus6;
    if (lastDayOfMonth.isBefore(maxAllowedToDate)) {
      maxAllowedToDate = lastDayOfMonth;
    }
    if (currentDate.isBefore(maxAllowedToDate)) {
      maxAllowedToDate = currentDate;
    }

    setToMax(currentDate);

    const isFromAfterTo = dayjs(selectedDateFrom).isAfter(
      dayjs(selectedDateTo),
    );
    const isDifferentMonth = fromDateMonth !== toDateMonth;
    const isMoreThan6Days =
      dayjs(selectedDateTo).diff(dayjs(selectedDateFrom), "day") > 6;

    if (isFromAfterTo || isDifferentMonth || isMoreThan6Days) {
      isAdjustingDates.current = true;
      setSelectedDateTo(maxAllowedToDate);
      props.selectedDateToHandler(maxAllowedToDate);
      setTimeout(() => {
        isAdjustingDates.current = false;
      }, 0);
    }
  }, [
    isPayoutDashboard?.payout,
    isPayoutDashboard?.clawback,
    selectedDateFrom,
  ]);

  useEffect(() => {
    if (isAdjustingDates.current) return;
    if (!isPayoutDashboard?.payout || isPayoutDashboard?.clawback) return;

    const currentDate = dayjs();
    const fromDateMonth = dayjs(selectedDateFrom).month();
    const toDateMonth = dayjs(selectedDateTo).month();
    const firstDayOfMonth = dayjs(selectedDateTo).startOf("month");
    const toDateMinus6 = dayjs(selectedDateTo).subtract(6, "day");

    let minAllowedFromDate = toDateMinus6;
    if (firstDayOfMonth.isAfter(minAllowedFromDate)) {
      minAllowedFromDate = firstDayOfMonth;
    }

    const isFromAfterTo = dayjs(selectedDateFrom).isAfter(
      dayjs(selectedDateTo),
    );
    const isDifferentMonth = fromDateMonth !== toDateMonth;
    const isMoreThan6Days =
      dayjs(selectedDateTo).diff(dayjs(selectedDateFrom), "day") > 6;

    if (isFromAfterTo || isDifferentMonth || isMoreThan6Days) {
      isAdjustingDates.current = true;
      setSelectedDateFrom(minAllowedFromDate);
      props.selectedDateFromHandler(minAllowedFromDate);
      setTimeout(() => {
        isAdjustingDates.current = false;
      }, 0);
    }

    setToMax(currentDate);
  }, [isPayoutDashboard?.payout, isPayoutDashboard?.clawback, selectedDateTo]);

  useEffect(() => {
    if (isPayoutDashboard?.clawback) {
      const currentDate = dayjs();
      const twelveMonthsAgo = dayjs().subtract(12, "month");

      // For clawback: to date max is always current date
      setToMax(currentDate);

      // If to date is after current date, set it to current date
      if (dayjs(selectedDateTo).isAfter(currentDate)) {
        setSelectedDateTo(currentDate);
        props.selectedDateToHandler(currentDate);
      }

      // Only enforce minimum constraint for from date (don't auto-update it)
      // If from date is before 12 months ago, set it to 12 months ago
      if (selectedDateFrom) {
        if (dayjs(selectedDateFrom).isBefore(twelveMonthsAgo)) {
          setSelectedDateFrom(twelveMonthsAgo);
          props.selectedDateFromHandler(twelveMonthsAgo);
        }
      }
    } else if (!isPayoutDashboard?.payout) {
      setToMax(new Date());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPayoutDashboard?.clawback, selectedDateTo]);

  let clearFrom = true;
  if (selectedDateFrom === null) {
    clearFrom = false;
  }
  let clearTo = true;
  if (selectedDateTo === null) {
    clearTo = false;
  }
  const resetApiData = () => {
    return dispatch(resetData());
  };
  const resetSales = () => {
    return dispatch(resetSalesForValue());
  };
  let fromMax = new Date();
  const fromDateMax = new Date(
    fromMax.getFullYear(),
    fromMax.getMonth(),
    fromMax.getDate(),
  );

  const units = [
    {
      value: "1000",
      label: "Thousand (K)",
    },
    {
      value: "100000",
      label: "Lakh     (L)",
    },
    {
      value: "10000000",
      label: "Crore    (Cr)",
    },
  ];

  const handleChange = (unit) => (event) => {
    const values = {
      1000: "(K)",
      100000: "(L)",
      10000000: "(Cr)",
    };
    const shortLabel = values[event.target.value];
    setValues({
      [unit]: event.target.value,
      label: shortLabel,
    });
  };

  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = React.useState(false);
  const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] =
    React.useState(false);

  const handleMobileSiteChange = (selectedSite) => {
    dispatch(setSelectedSite(selectedSite));
    if (props.fetchHierarchyTiles) {
      props.fetchHierarchyTiles(selectedSite);
    }
    setIsMobileDropdownOpen(false);
  };

  const handleDesktopSiteChange = (selectedSite) => {
    dispatch(setSelectedSite(selectedSite));
    if (props.fetchHierarchyTiles) {
      props.fetchHierarchyTiles(selectedSite);
    }
    setIsDesktopDropdownOpen(false);
  };

  const toggleMobileDropdown = () => {
    setIsMobileDropdownOpen(!isMobileDropdownOpen);
  };

  const toggleDesktopDropdown = () => {
    setIsDesktopDropdownOpen(!isDesktopDropdownOpen);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileDropdownOpen &&
        !event.target.closest(".mobile-site-dropdown")
      ) {
        setIsMobileDropdownOpen(false);
      }
      if (
        isDesktopDropdownOpen &&
        !event.target.closest(".desktop-site-dropdown")
      ) {
        setIsDesktopDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileDropdownOpen, isDesktopDropdownOpen]);

  // console.log("CURRENT PATH: ", window.location.pathname);

  return (
    <>
      {global.isSessionExpired === true ||
      window.location.href.includes("sessionExpired") ||
      tilesData?.loading ||
      tilesData?.error ? (
        <div></div>
      ) : (
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={dateButton.open}
            onClose={handleClose}
            TransitionComponent={dateButton.Transition}
            message="Date and Value Unit has been set."
            key={dateButton.Transition.name}
            autoHideDuration={5000}
            action={action}
          />
          <nav
            className="navbar navbar-expand-lg navbar-light bg-light wow fadeInDown"
            data-wow-delay=".2s"
            data-wow-duration="0.7s"
            data-cy="navbar"
          >
            <button
              type="button"
              id="sidebarCollapse"
              className="btn btn-info"
              data-cy="menu-icon"
              onClick={() => props.setShowSidebar()}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icons/menu.png"}
                alt="menu-icon"
              />
            </button>

            <ul className="navbar-nav mr-auto"></ul>
            <div className="jiologo" data-cy="brand-logo">
              <a href="/">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/new-jio-logo.svg"
                  }
                  alt="jio-logo"
                />
              </a>
            </div>
            <div className="d-flex">
              <style>
                {`
                  /* Desktop Site Dropdown */
                  .desktop-site-dropdown {
                    display: block;
                    position: relative;
                  }
                  
                  .desktop-site-selector {
                    background: #f8f9fa;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    border-radius: 4px;
                    padding: 8px 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    min-width: 160px;
                    transition: all 0.2s;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                  }
                  
                  .desktop-site-selector:hover {
                    background: #e9ecef;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
                  }
                  
                  .desktop-site-selector i {
                    color: #495057;
                    font-size: 14px;
                  }
                  
                  .desktop-site-text {
                    color: #495057;
                    font-size: 14px;
                    font-weight: 500;
                    flex-grow: 1;
                    text-align: left;
                  }
                  
                  .desktop-site-arrow {
                    color: #495057;
                    font-size: 12px;
                    transition: transform 0.2s;
                  }
                  
                  .desktop-site-arrow.open {
                    transform: rotate(180deg);
                  }
                  
                  .desktop-site-list {
                    position: absolute;
                    top: 45px;
                    left: 0;
                    right: 0;
                    background: white;
                    border: 1px solid #dee2e6;
                    border-radius: 8px;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                    z-index: 1000;
                    max-height: 250px;
                    overflow-y: auto;
                    animation: fadeInDown 0.2s ease-out;
                  }
                  
                  .desktop-site-item {
                    padding: 12px 16px;
                    border-bottom: 1px solid #f1f3f4;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    color: #495057;
                    font-size: 14px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                  }
                  
                  .desktop-site-item:hover {
                    background-color: #f8f9fa;
                    color: #03007f;
                    padding-left: 20px;
                  }
                  
                  .desktop-site-item:last-child {
                    border-bottom: none;
                    border-bottom-left-radius: 8px;
                    border-bottom-right-radius: 8px;
                  }
                  
                  .desktop-site-item:first-child {
                    border-top-left-radius: 8px;
                    border-top-right-radius: 8px;
                  }
                  
                  .desktop-site-item.active {
                    background-color: #03007f;
                    color: white;
                    font-weight: 600;
                    position: relative;
                  }
                  
                  .desktop-site-item.active:hover {
                    background-color: rgb(43, 41, 147);;
                    padding-left: 16px;
                    color: white;
                  }
                  
                  .desktop-site-item.active::before {
                    content: '✓';
                    position: absolute;
                    right: 12px;
                    font-weight: bold;
                  }
                  
                  .mobile-site-dropdown {
                    display: none;
                  }
                  
                  /* Mobile Site Dropdown */
                  @media (max-width: 768px) {
                    .desktop-site-dropdown {
                      display: none;
                    }
                    
                    .mobile-site-dropdown {
                      display: block;
                      position: relative;
                    }
                    
                    .mobile-site-icon {
                      border: 1px solid rgba(255, 255, 255, 0.3);
                      border-radius: 4px;
                      padding: 8px 12px;
                      margin-right: 10px;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      transition: all 0.2s;
                      min-width: 44px;
                      height: 40px;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    }
                    
                    .mobile-site-icon:hover {
                      transform: translateY(-1px);
                      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
                    }
                    
                    .mobile-site-icon i {
                      color: #495057 !important;
                      font-size: 16px !important;
                    }
                    
                    .mobile-site-list {
                      position: absolute;
                      top: 45px;
                      right: 0;
                      background: white;
                      border: 1px solid #dee2e6;
                      border-radius: 8px;
                      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                      z-index: 1000;
                      max-height: 200px;
                      overflow-y: auto;
                      min-width: 120px;
                      width: max-content;
                      max-width: calc(100vw - 20px);
                      animation: fadeInDown 0.2s ease-out;
                      white-space: nowrap;
                      transform: translateX(0);
                    }
                    
                    /* Adjust dropdown position if it goes off-screen */
                    @media (max-width: 480px) {
                      .mobile-site-list {
                        right: -10px;
                        min-width: 140px;
                      }
                    }
                    
                    @media (max-width: 350px) {
                      .mobile-site-list {
                        right: -20px;
                        left: auto;
                        min-width: 120px;
                        transform: translateX(-50%);
                      }
                    }
                    
                    @keyframes fadeInDown {
                      from {
                        opacity: 0;
                        transform: translateY(-10px);
                      }
                      to {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                    
                    .mobile-site-item {
                      padding: 12px 16px;
                      border-bottom: 1px solid #f1f3f4;
                      cursor: pointer;
                      transition: all 0.2s ease;
                      color: #495057;
                      font-size: 14px;
                      font-weight: 500;
                      display: flex;
                      align-items: center;
                    }
                    
                    .mobile-site-item:hover {
                      background-color: #f8f9fa;
                      color: #03007f;
                      padding-left: 20px;
                    }
                    
                    .mobile-site-item:last-child {
                      border-bottom: none;
                      border-bottom-left-radius: 8px;
                      border-bottom-right-radius: 8px;
                    }
                    
                    .mobile-site-item:first-child {
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                    }
                    
                    .mobile-site-item.active {
                      background-color: #03007f;
                      color: white;
                      font-weight: 600;
                      position: relative;
                    }
                    
                    .mobile-site-item.active:hover {
                      background-color:rgb(58, 56, 206);
                      padding-left: 16px;
                      color: white;
                    }
                    
                    .mobile-site-item.active::before {
                      content: '✓';
                      position: absolute;
                      right: 12px;
                      font-weight: bold;
                    }
                  }
                `}
              </style>

              {/* Desktop Site Dropdown - Only show on /partneranalytics/pcredirect/ when TOKEN = "N" */}
              {window.location.pathname === "/partneranalytics/pcredirect/" &&
                window.TOKEN === "N" && (
                  <div className="desktop-site-dropdown">
                    <div
                      className="desktop-site-selector"
                      onClick={toggleDesktopDropdown}
                      title={`Current site: ${site}`}
                    >
                      <i className="fa fa-compass" aria-hidden="true"></i>
                      <span className="desktop-site-text">
                        {site || "Select Site"}
                      </span>
                      <i
                        className={`fa fa-chevron-down desktop-site-arrow ${
                          isDesktopDropdownOpen ? "open" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                    </div>

                    {isDesktopDropdownOpen && (
                      <div className="desktop-site-list">
                        {sites.length > 0 &&
                          sites.map((siteOption, index) => (
                            <div
                              key={index}
                              className={`desktop-site-item ${
                                site === siteOption ? "active" : ""
                              }`}
                              onClick={() =>
                                handleDesktopSiteChange(siteOption)
                              }
                            >
                              {siteOption}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                )}

              {/* Mobile Site Dropdown - Only show on /partneranalytics/pcredirect/ when TOKEN = "N" */}
              {window.location.pathname === "/partneranalytics/pcredirect/" &&
                window.TOKEN === "N" && (
                  <div className="mobile-site-dropdown">
                    <div
                      className="mobile-site-icon"
                      onClick={toggleMobileDropdown}
                      title={`Current site: ${site}`}
                    >
                      <i
                        className="fa fa-compass"
                        aria-hidden="true"
                        style={{ color: "white" }}
                      ></i>
                    </div>

                    {isMobileDropdownOpen && (
                      <div className="mobile-site-list">
                        {sites.length > 0 &&
                          sites.map((siteOption, index) => (
                            <div
                              key={index}
                              className={`mobile-site-item ${
                                site === siteOption ? "active" : ""
                              }`}
                              onClick={() => handleMobileSiteChange(siteOption)}
                            >
                              {siteOption}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                )}
              <div
                data-cy="settings-icon"
                style={{
                  display: [
                    "/partneranalytics/pcredirect/",
                    "/partneranalytics/pcredirect/operationalDashboard",
                    "/partneranalytics/pcredirect/schemePerformance",
                    "/partneranalytics/pcredirect/schemeOverview",
                    // "/partneranalytics/pcredirect/partnersClawbackReport",
                  ].includes(window.location.pathname)
                    ? "none"
                    : "block",
                }}
              >
                <button
                  className="btn btn-sm bg-light text-white"
                  type="button"
                  id="slideFilters"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Dates Selection"
                  onClick={() => {
                    // console.log("CALENDAR TOGGLE CLICKED");
                    setToggleCalendarFilter(!toggleCalendarFilter);
                  }}
                >
                  <i className="fa fa-2x fa-calendar " aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </nav>
          {props.isHierarchyFetched && showHeader && (
            <div
              // className="collapse"
              className={toggleCalendarFilter ? "" : "collapse"}
              id="collapseExample"
              style={{ display: toggleCalendarFilter ? "block" : "none" }}
            >
              <div className="secheader">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-4">
                      <h2 className="welcometxt">{`Welcome ${
                        name !== "" ? name : orgId !== "" ? orgId : agentId
                      } (${partnerName}) `}</h2>
                    </div>
                    <div className="col-md-8">
                      <ul className="distrubuterform">
                        <li>
                          <div className="form-group">
                            <label htmlFor="sel1">Value Unit</label>
                            <select
                              className="form-control"
                              id="sel1"
                              name="sellist1"
                              onChange={handleChange("unit")}
                            >
                              {units.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </li>
                        <li>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="From"
                              value={selectedDateFrom}
                              onChange={(date) => {
                                setSelectedDateFrom(date);
                              }}
                              inputFormat="DD-MMM-YYYY"
                              minDate={fromMin}
                              maxDate={fromDateMax}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  fullWidth
                                  error={
                                    !dayjs(selectedDateFrom).isValid() ||
                                    dayjs(selectedDateFrom).isBefore(
                                      fromMin,
                                      "day",
                                    ) ||
                                    (!!selectedDateTo &&
                                      dayjs(selectedDateFrom).isAfter(
                                        selectedDateTo,
                                        "day",
                                      ))
                                  }
                                  helperText={
                                    !dayjs(selectedDateFrom).isValid()
                                      ? "Invalid Date Format."
                                      : dayjs(selectedDateFrom).isBefore(
                                            fromMin,
                                            "day",
                                          )
                                        ? "From Date cannot be before 6 months."
                                        : !!selectedDateTo &&
                                            dayjs(selectedDateFrom).isAfter(
                                              selectedDateTo,
                                              "day",
                                            )
                                          ? "From Date cannot be after To Date."
                                          : ""
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    maxLength: 11,
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </li>
                        <li>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="To"
                              value={selectedDateTo}
                              onChange={(date) => {
                                setSelectedDateTo(date);
                              }}
                              inputFormat="DD-MMM-YYYY"
                              minDate={fromMin}
                              maxDate={toMax}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  fullWidth
                                  error={
                                    !dayjs(selectedDateTo).isValid() ||
                                    dayjs(selectedDateTo).isBefore(
                                      selectedDateFrom,
                                      "day",
                                    ) ||
                                    dayjs(selectedDateTo).isAfter(toMax, "day")
                                  }
                                  helperText={
                                    !dayjs(selectedDateTo).isValid()
                                      ? "Invalid Date Format."
                                      : dayjs(selectedDateTo).isBefore(
                                            selectedDateFrom,
                                            "day",
                                          )
                                        ? "To Date cannot be before From Date."
                                        : dayjs(selectedDateTo).isAfter(
                                              toMax,
                                              "day",
                                            )
                                          ? "To Date cannot be after today's date."
                                          : ""
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    maxLength: 11,
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </li>

                        <li className="last">
                          <button
                            type="button"
                            className="btn btn-danger mt-3"
                            disabled={
                              !dayjs(selectedDateFrom).isValid() ||
                              dayjs(selectedDateFrom).isBefore(
                                fromMin,
                                "day",
                              ) ||
                              (!!selectedDateTo &&
                                dayjs(selectedDateFrom).isAfter(
                                  selectedDateTo,
                                  "day",
                                )) ||
                              !dayjs(selectedDateTo).isValid() ||
                              dayjs(selectedDateTo).isBefore(
                                selectedDateFrom,
                                "day",
                              ) ||
                              dayjs(selectedDateTo).isAfter(toMax, "day")
                            }
                            onClick={() => {
                              handleClick(SlideTransition);
                              if (
                                headerSelectedDateFrom !==
                                  dayjs(selectedDateFrom).format(
                                    "DD-MMM-YYYY",
                                  ) ||
                                headerSelectedDateTo !==
                                  dayjs(selectedDateTo).format("DD-MMM-YYYY")
                              ) {
                                resetApiData();
                                dispatch(resetScheme());
                                dispatch(resetEd1());
                              }
                              if (headerUnit.unit !== values.unit) {
                                resetSales();
                              }
                              props.selectedDateFromHandler(selectedDateFrom);
                              props.selectedDateToHandler(selectedDateTo);
                              props.valueUnitHandler(values);
                              if (
                                partnerRoleType &&
                                !validatePartnerRoleType(partnerRoleType)
                                  .showFilters
                              ) {
                                dispatch(setRun());
                              }
                            }}
                          >
                            Set
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

CustomHeader.propTypes = {
  selectedDateFromHandler: PropTypes.func,
  selectedDateToHandler: PropTypes.func,
  valueUnitHandler: PropTypes.func,
};
